import React from 'react';
import Tooltip from 'rc-tooltip';

import styles from './tooltipWhiteStyles';

const TooltipWhite = ({ children, overlay, trigger = ['hover'], placement, ...props }) => {
  return (
    <Tooltip
      overlay={overlay}
      trigger={trigger}
      placement={placement}
      overlayClassName={styles.whiteThemed}
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default TooltipWhite;
